import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { Component } from 'react';
import { BASE_PLOT_OPTIONS, CHART_BASE_CONFIG, X_AXIS_BASE_CONFIG, Y_AXIS_BASE_CONFIG } from './ChartBaseConfig';

export default class Past extends Component {
	chart; // highcharts object
	offset; // chart container width
	translateX;
	state = {
		options: this.getChartOptions() // highcharts configuration
	};
	updateDimensions() {
		this.offset = this.chart.container.parentElement.clientWidth;
		const interval = parseInt(process.env.REACT_APP_PAST_CHARTS_INTEVAL, 10);
		this.chart.setSize(this.props.data.length * (this.offset / (this.props.frameRate * interval)));
		this.translateChart(this.props.currentDataIndex);
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions.bind(this));
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions.bind(this));
	}
	getChartOptions() {
		return {
			...CHART_BASE_CONFIG,
			chart: {
				backgroundColor: null,
				animation: false,
				margin: [0, 0, 0, 0],
				width: this.props.data.length * 6
			},
			tooltip: {
				animation: false,
				shared: true,
				formatter: function() {
					return false;
				}
			},
			series: [{
				data: this.props.data.map(a => [a.timestamp, a.skewedPrediction]),
				type: 'areaspline',
				color: this.props.lineColor, //getColorGradient(this.props.lineColor),
				fillColor : {
					linearGradient: {
						x1: 0,
						y1: 0,
						x2: 0,
						y2: 1 // gradient on Y axis from top to bottom
					},
					stops : [
						[0, this.props.lineColor],
						[1, Highcharts.Color('#222').setOpacity(0).get('rgba')]
					]
				},
				zIndex: 5,
				marker: { symbol: 'circle' },
				name: 'Ghost Prediction'
			},{
				type: 'spline',
				color: '#019fdf', //getColorGradient('#019fdf'),
				data: this.props.data.map(a => [a.timestamp, a.valueUpperBound]), // upper bound spline
				name: 'Upper Bound',
				marker: { symbol: 'circle' },
				zIndex: 1
			},{
				type: 'spline',
				color: '#019fdf', //getColorGradient('#019fdf'),
				data: this.props.data.map(a => [a.timestamp, a.valueLowerBound]),  // lower bound spline
				marker: { symbol: 'circle' },
				name: 'Lower Bound',
				zIndex: 1
			},{
				type: 'areaspline',
				color: '#019fdf', //getColorGradient('#019fdf'),
				stacking: true,
				name: 'areainterval1',
				lineWidth: 0,
				shadow: false,
				enableMouseTracking: false,
				marker: { enabled: false },
				data: this.props.data.map(a => [a.timestamp, a.valueUpperBound - a.valueLowerBound]),  // filled interval between bounds
			},{
				id: 'transparent',
				type: 'areaspline',
				color: 'rgba(255,255,255,0)',
				name: 'areainterval2',
				stacking: true,
				lineWidth: 0,
				enableMouseTracking: false,
				shadow: false,
				data: this.props.data.map(a => [a.timestamp, a.valueLowerBound]), // lower bound invisible area to stack under filler interval
			}],
			plotOptions: {
				...BASE_PLOT_OPTIONS,
			},
			xAxis: [{
				...X_AXIS_BASE_CONFIG,
				type: this.props.logarithmic ? 'logarithmic' : undefined,
			}],
			yAxis: [{
				...Y_AXIS_BASE_CONFIG,
				lineWidth: 1,
				min: this.props.minsAndMaxes.min,
				max: this.props.minsAndMaxes.max,
			}]
		}
	}
	componentDidUpdate(prevProps) {
		if (this.props.videoReady !== prevProps.videoReady && this.props.videoReady) {
			setTimeout(() => {
				this.chart.reflow(); // we need to wait for the video and page to be fully rendered to recompute chart dimensions
				this.updateDimensions();
			}, 1000);
		}
	}
	shouldComponentUpdate(nextProps){
		if (this.chart && this.props.currentDataIndex !== nextProps.currentDataIndex) {
			this.translateChart(nextProps.currentDataIndex);
		}
		return this.props.videoReady !== nextProps.videoReady && nextProps.videoReady;
	}
	translateChart(currentDataIndex) {
		this.translateX = - ((this.chart.container.clientWidth / this.props.data.length) * currentDataIndex) + this.offset
		this.chart.container.style.transform = `translateX(${this.translateX}px) translateZ(0)`;

		if ( this.props.onChartTranslate){
			this.props.onChartTranslate();
		}
	}
	chartCallback(chart) {
		this.chart = chart;
		this.chart.container.style.transform = 'translateX(1000px)';
		this.chart.get('transparent').area.hide();
	}
	render() {
		return (
			<HighchartsReact
				highcharts={Highcharts}
				options={this.state.options}
				callback={this.chartCallback.bind(this)}
			/>
		);
	}
}